import { InputPinCode, InputText, Loading } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys, MainRouteKeys } from 'routes/enums';
import {
  useCheckPhoneNoQuery,
  useGetAdminActionsQuery,
  useLoginMutation,
} from 'services';

import { formSchema } from './config';
import ModalRefferal from './ModalRefferal';
import jwtDecode from 'jwt-decode';
import { Roles } from 'configs/roles';
import { LocalStorageKey } from 'configs/constants';

type FormData = {
  phoneNumber: string;
  pinCode: string;
};

const LoginFeatures = () => {
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const [isVisible, setIsVisible] = useState<boolean>(false);

  const [isVisibleModalRefferal, setIsVisibleModalRefferal] =
    useState<boolean>(false);

  const { data, isFetching, refetch } = useCheckPhoneNoQuery({
    phoneNumber,
  });

  const { refetch: refetchAdminActions } = useGetAdminActionsQuery();

  const { mutateAsync } = useLoginMutation();

  useEffect(() => {
    if (phoneNumber && phoneNumber.length >= 10) {
      refetch();
    }
  }, [phoneNumber]);

  useEffect(() => {
    if (data && data.statusCode === 201) {
      setIsVisible(true);
      toast.success('Bạn chưa có mật khẩu, vui lòng tạo mật khẩu mới');
    } else {
      setIsVisible(false);
    }
  }, [data]);

  const handleForgotPassword = () => {
    navigate(AuthRouteKeys.OTP, { state: { phoneNumber } });
  };

  const handleSubmitForm = async (values: FormData) => {
    if (data?.statusCode === 201) {
      return navigate(AuthRouteKeys.OTP, {
        state: { phoneNumber, onlyAllowPhone: true },
      });
    }
    try {
      const dataLoginMutation = await mutateAsync(values);
      // Actions
      const { role } = jwtDecode<any>(dataLoginMutation.token);
      if (role === Roles.ADMIN) {
        const data = await refetchAdminActions();
        if (data.isError) {
          localStorage.removeItem(LocalStorageKey.ADMIN_ACTIONS);
        } else {
          localStorage.setItem(
            LocalStorageKey.ADMIN_ACTIONS,
            JSON.stringify(data?.data?.adminActions || []),
          );
        }
      } else {
        localStorage.removeItem(LocalStorageKey.ADMIN_ACTIONS);
      }

      // Handle Enter Refferal Code
      if (
        !!dataLoginMutation.isFirstLogin &&
        !!dataLoginMutation.isActiveReferralProgram
      ) {
        setIsVisibleModalRefferal(true);
      } else {
        navigate(MainRouteKeys.Personal, { replace: true });
      }
    } catch (error) {}
  };

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure: formSchema(!isVisible),
    onSubmit: handleSubmitForm,
  });

  return (
    <div className='login-form'>
      <form onSubmit={handleSubmit} autoComplete='off'>
        <div className='login-form__logo'>
          <img
            style={{ width: '288px' }}
            className='login-form__logo__img'
            src='/assets/images/logo-white.png'
            alt=''
          />
        </div>
        <Loading isLoading={isFetching}>
          <InputWraper
            label='Số điện thoại'
            inputProps={getInputProps('phoneNumber')}
            onChangeCallback={setPhoneNumber}
            component={InputText}
            isRequired={true}
          />

          <InputWraper
            label='Mật khẩu'
            inputProps={getInputProps('pinCode')}
            component={InputPinCode}
            isVisible={isVisible}
            isRequired={!isVisible}
          />
        </Loading>

        <div className='login-form__actions'>
          <Button
            label={data?.statusCode === 201 ? 'Thêm mật khẩu' : 'Đăng nhập'}
            type='submit'
            buttonType='success'
            isLoading={isSubmitting}
          />
          <Button
            label='Quên mật khẩu'
            type='button'
            onClick={handleForgotPassword}
            buttonType='primary-outline'
          />
        </div>
      </form>
      <ModalRefferal
        isOpen={isVisibleModalRefferal}
        onSuccess={() => {
          // Handle successful referral code entry
          setIsVisibleModalRefferal(false);
          navigate(MainRouteKeys.Personal, { replace: true });
        }}
        onClose={() => {
          setIsVisibleModalRefferal(false);
          navigate(MainRouteKeys.Personal, { replace: true });
        }}
      />
    </div>
  );
};

export default LoginFeatures;
